module.exports = __webpack_public_path__ + "static/media/plain-ball-1.134bfebf.gif";